import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { LegalRolandStepParams } from './types'
import { previousInsuranceGotCanceledSchema } from './types'

export const previousInsuranceGotCanceled = (params: LegalRolandStepParams) => {
  const schema = previousInsuranceGotCanceledSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey:
            'sharedFlows_legal:steps.legal_roland.previous_insurance_got_canceled.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_insurance_got_canceled'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'login',
    subFlow: SubFlow.LegalRoland,
  } as const satisfies AnyStepConfiguration
}
